import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  // 全局参数
  state: {
    nvIndex: "0"
  },
  mutations: {},
  actions: {},
  modules: {}
});
